import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDate } from '@/datas/DateFormats'
import { getNow } from './date'

const Bids = RepositoryFactory.get('bids')

const checkVisibilityOnScroll = (target, id, storage, blockClass) => {
  /** Получаем позиции элемента **/
  const { top, bottom } = target?.getBoundingClientRect()
  const block = blockClass
    ? document.querySelector(blockClass)?.getBoundingClientRect()
    : undefined
  const targetPosition = {
    top: top >= 0 ? top : 0,
    bottom,
  }
  /** Получаем позиции окна **/
  const windowPosition = {
    top: block?.top || 0,
    bottom: block?.bottom || document.documentElement.clientHeight,
  }

  /** Позиция верхней части элемента больше позиции верхней чайти окна и
   позиция нижней части элемента меньше позиции нижней чайти окна **/
  if (
    targetPosition.top >= windowPosition.top &&
    targetPosition.bottom < windowPosition.bottom
  ) {
    Bids.setViewed(id)
    const now = getNow(defaultDate)
    const newArr = [...storage[now], id]

    storage[now] = [...new Set(newArr)]
    localStorage.setItem('port_viewed_bids', JSON.stringify(storage))
  }
}

/** Проверяем есть ли сегодня просмотренные элементы, если есть запускаем проверку видимости **/
const callback = (elements, blockClass) => {
  const storage = JSON.parse(localStorage.getItem('port_viewed_bids'))
  const now = getNow(defaultDate)
  const viewed = storage && storage[now] ? storage : { [now]: [] }

  elements.map(el => {
    if (!viewed[now].includes(el.dataset.id)) {
      checkVisibilityOnScroll(el, el.dataset.id, viewed, blockClass)
    }
  })
}

/** Делаем задержку прокрутки на заданное время **/
function throttle(fn, wait = 1000) {
  let time = Date.now()

  return () => {
    if (time + wait - Date.now() < 0) {
      fn()
      time = Date.now()
    }
  }
}

/** Проверяем роль[перевозчик] и наличие элементов, если ок, то вешаем на событие скролл, если нет - удаляем **/
export const isBidViewed = (self, blockClass = '') => {
  if (self.userInfo.user_type === 4) {
    const block = blockClass ? document.querySelector(blockClass) : window
    const elements = [...document.querySelectorAll('.bid-item-view')]
    const fn = throttle(() => callback(elements, blockClass))

    if (self._scrollHandler) {
      block?.removeEventListener('scroll', self._scrollHandler)
    }
    if (elements.length && block) {
      block?.addEventListener('scroll', fn)
    }
    /** Удаляем событие скролл перед дестроем компонента **/
    self?.$once('hook:beforeDestroy', () =>
      block?.removeEventListener('scroll', fn),
    )

    /** Запукаем один раз сразу**/
    callback(elements, blockClass)
  }
}
